export default "__VITE_ASSET__a9681a71__"